<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>《灵域传说》是一款火影 IP 二次元卡牌手游，延续原作热血忍道世界观，还原木叶完整忍者世界。集结全系列经典人气忍者，融合卡牌收集、策略布阵与深度养成玩法，搭配专属羁绊联动，征战忍村领地、挑战尾兽 BOSS，开启专属于你的忍者冒险征程！</p>
    <!-- <pre> -->
    <div class="content">
      <div class="content-item">
        <h4>【经典忍者复刻】</h4>
          二次元精致立绘打磨细节质感，高度还原原著人气忍者！鸣人热血朝气、佐助冷峻孤傲、小樱果敢坚韧，贴合每位角色独有气质，原画画质双在线，满足全忍者收集养成喜好！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【策略羁绊对战】</h4>
          多元定位忍者随心搭配，角色专属奥义忍术各具特色！自由组合卡组打造专属打法，编排阵容激活羁绊联动；推进主线快速升级解锁全部玩法，灵活排兵打出连招，轻松横扫各路强敌！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【多元热血玩法】</h4>
          复刻木叶经典场景与原作剧情，矿脉占领、九尾之劫、奈落神堕海量限时副本。领地争夺、组织团战、实时竞技 PK，运筹帷幄登顶忍界巅峰！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【轻快零压操作】</h4>
          简化繁琐养成操作，告别冗长枯燥对战！短局快节奏忍术激斗，碎片时间随时上线开战，新手零门槛轻松上手，畅快释放各式招牌忍术！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
